<div class="container">
    <div class="title" data-cy="ops-settings-accounts-session-timeout-modal-header">
        {{ 'account-setting.edit.session.timeout.dialog.title' | translate }}
    </div>

    <div class="text-container">
        <div class="logout-text">
            <span>
                {{ 'account-setting.edit.session.timeout.dialog.text' | translate }}
            </span>
            <span class="selected-timeout">
                <span>
                    {{
                        'account-setting.edit.session.timeout.dialog.selected-timeout'
                            | translate: { timeout: selectedTimeout }
                    }}
                </span>
                <span *ngIf="selectedTimeout === 0">
                    {{ 'account-setting.edit.session.timeout.dialog.selected-timeout.disabled' | translate }}
                </span>
            </span>
        </div>
    </div>

    <div class="slider-container">
        <mat-slider min="0" max="60" step="5" discrete="true">
            <input matSliderThumb [(ngModel)]="selectedTimeout" />
        </mat-slider>
        <div class="ticks">
            <div *ngFor="let t of timeoutSet" class="tick-container" (click)="selectedTimeout = t">
                <div class="tick"></div>
                <span data-cy="ops-settings-accounts-session-timeout-timeout-value">{{ t }}</span>
            </div>
        </div>
    </div>
</div>

<div class="buttons-container">
    <div class="cancel button" (click)="cancelClick()">
        {{ 'shipyard.create.dialog.form.button.cancel' | translate }}
    </div>
    <div
        class="create button"
        data-cy="ops-settings-accounts-session-timeout-save-button"
        (click)="saveChanges()"
        [class.disabled]="selectedTimeout === data.sessionTimeout">
        {{ 'account-setting.edit.session.timeout.dialog.save' | translate }}
    </div>
</div>
